import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'ApplicationContainerUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ApplicationContainerUI/ApplicationContainerUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesListUI/AssignPermissionToRolesListUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesUI/AssignPermissionToRolesUI.vue'),
    },
    {
      name: 'CountryLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CountryLookupUI/CountryLookupUI.vue'),
    },
    {
      name: 'CultureListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CultureListUI/CultureListUI.vue'),
    },
    {
      name: 'CurrencyLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CurrencyLookupUI/CurrencyLookupUI.vue'),
    },
    {
      name: 'DashboardUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DashboardUI/DashboardUI.vue'),
    },
    {
      name: 'DeveloperMenuUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DeveloperMenuUI/DeveloperMenuUI.vue'),
    },
    {
      name: 'HelpVideoGroupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HelpVideoGroupUI/HelpVideoGroupUI.vue'),
    },
    {
      name: 'HelpVideoUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HelpVideoUI/HelpVideoUI.vue'),
    },
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'KnownIanaTimeZoneUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/KnownIanaTimeZoneUI/KnownIanaTimeZoneUI.vue'),
    },
    {
      name: 'MunicipalityLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MunicipalityLookupUI/MunicipalityLookupUI.vue'),
    },
    {
      name: 'NeosBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosBaseUI/NeosBaseUI.vue'),
    },
    {
      name: 'NeosDataExportPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportPropertyUI/NeosDataExportPropertyUI.vue'),
    },
    {
      name: 'NeosDataExportSortsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportSortsUI/NeosDataExportSortsUI.vue'),
    },
    {
      name: 'NeosDataExportUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportUI/NeosDataExportUI.vue'),
    },
    {
      name: 'NeosDataImportColumnMappingEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportColumnMappingEditUI/NeosDataImportColumnMappingEditUI.vue'),
    },
    {
      name: 'NeosDataImportColumnMappingListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportColumnMappingListUI/NeosDataImportColumnMappingListUI.vue'),
    },
    {
      name: 'NeosDataImportSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.right,
      component: () => import('./views/NeosDataImportSettingsUI/NeosDataImportSettingsUI.vue'),
    },
    {
      name: 'NeosDataImportStagingEditUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingEditUI/NeosDataImportStagingEditUI.vue'),
    },
    {
      name: 'NeosDataImportStagingListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingListUI/NeosDataImportStagingListUI.vue'),
    },
    {
      name: 'NeosDataImportStagingRowUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingRowUI/NeosDataImportStagingRowUI.vue'),
    },
    {
      name: 'NeosDataImportTargetPropertyLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTargetPropertyLookupUI/NeosDataImportTargetPropertyLookupUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateEditUI/NeosDataImportTemplateEditUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateListUI/NeosDataImportTemplateListUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateLookupUI/NeosDataImportTemplateLookupUI.vue'),
    },
    {
      name: 'NeosDataImportTypeLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTypeLookupUI/NeosDataImportTypeLookupUI.vue'),
    },
    {
      name: 'NeosDataImportUploadFileUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.right,
      component: () => import('./views/NeosDataImportUploadFileUI/NeosDataImportUploadFileUI.vue'),
    },
    {
      name: 'PermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PermissionUI/PermissionUI.vue'),
    },
    {
      name: 'ProvinceStateLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProvinceStateLookupUI/ProvinceStateLookupUI.vue'),
    },
    {
      name: 'ReportLightPreviewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReportLightPreviewUI/ReportLightPreviewUI.vue'),
    },
    {
      name: 'ReportPreviewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReportPreviewUI/ReportPreviewUI.vue'),
    },
    {
      name: 'UnitTypeLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnitTypeLookupUI/UnitTypeLookupUI.vue'),
    },
    {
      name: 'UserAccountAvailableUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountAvailableUI/UserAccountAvailableUI.vue'),
    },
    {
      name: 'UserAccountListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountListUI/UserAccountListUI.vue'),
    },
    {
      name: 'UserAccountLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountLookupUI/UserAccountLookupUI.vue'),
    },
    {
      name: 'UserAccountUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUI/UserAccountUI.vue'),
    },
    {
      name: 'UserAccountUserRoleEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleEntityUI/UserAccountUserRoleEntityUI.vue'),
    },
    {
      name: 'UserAccountUserRoleMultiClusterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleMultiClusterUI/UserAccountUserRoleMultiClusterUI.vue'),
    },
    {
      name: 'UserAccountUserRoleUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleUI/UserAccountUserRoleUI.vue'),
    },
    {
      name: 'UserPermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserPermissionUI/UserPermissionUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsJobUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsJobUI/UserReportPrintSettingsJobUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsListUI/UserReportPrintSettingsListUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsUI/UserReportPrintSettingsUI.vue'),
    },
    {
      name: 'UserRoleAssignmentUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserRoleAssignmentUI/UserRoleAssignmentUI.vue'),
    },
    {
      name: 'UserSettingsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserSettingsUI/UserSettingsUI.vue'),
    },
    {
      name: 'WhatsNewDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/WhatsNewDetailUI/WhatsNewDetailUI.vue'),
    },
    {
      name: 'WhatsNewReportUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/WhatsNewReportUI/WhatsNewReportUI.vue'),
    },
    {
      name: 'WhatsNewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/WhatsNewUI/WhatsNewUI.vue'),
    },
  ],
}
